var _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.41,
    y: 72.24,
    width: 194,
    height: 150.36,
    transform: "translate(630.82 294.85) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.37,
    y: 72.24,
    width: 194,
    height: 150.36,
    transform: "translate(622.74 294.85) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.01,
    y: 222.6,
    width: 207.4,
    height: 8.7,
    transform: "translate(617.43 453.91) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.46,
    y: 222.6,
    width: 198.46,
    height: 8.7,
    transform: "translate(599.38 453.91) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.01,
    y: 57.67,
    width: 134.72,
    height: 179.5,
    transform: "translate(458.8 -163.95) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.31 214.78 338.58 80.06 287.32 80.06 237.06 214.78 288.31 214.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.37 214.78 375.63 80.06 347.39 80.06 297.13 214.78 325.37 214.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.01,
    y: 143.38,
    width: 134.72,
    height: 8.08,
    transform: "translate(458.8 -163.95) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.79,
    y: 145.9,
    width: 134.72,
    height: 3.05,
    transform: "translate(370.57 -75.73) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.58,
    y: 145.9,
    width: 134.72,
    height: 3.05,
    transform: "translate(464.36 -169.52) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.24,
    y: 72.24,
    width: 75.93,
    height: 156.09,
    transform: "translate(256.41 300.58) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.52,
    y: 72.24,
    width: 83.8,
    height: 156.09,
    transform: "translate(242.84 300.58) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.96,
    y: 121.97,
    width: 128.93,
    height: 56.64,
    transform: "translate(271.71 28.87) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.9,
    y: 135.12,
    width: 69.04,
    height: 30.33,
    rx: 5.41,
    transform: "translate(271.71 28.87) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.85,
    y: 258.89,
    width: 30.43,
    height: 106.44,
    rx: 12,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 262.44,
    width: 20.57,
    height: 99.33,
    rx: 9.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.96,
    y: 258.89,
    width: 30.43,
    height: 106.44,
    rx: 12,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.6,
    y: 262.44,
    width: 20.57,
    height: 99.33,
    rx: 9.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.06,
    y: 258.89,
    width: 30.43,
    height: 106.44,
    rx: 12,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.7,
    y: 262.44,
    width: 20.57,
    height: 99.33,
    rx: 9.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.16,
    y: 258.89,
    width: 30.43,
    height: 106.44,
    rx: 12,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.8,
    y: 262.44,
    width: 20.57,
    height: 99.33,
    rx: 9.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.26,
    y: 258.89,
    width: 30.43,
    height: 106.44,
    rx: 12,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.91,
    y: 262.44,
    width: 20.56,
    height: 99.33,
    rx: 9.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.37,
    y: 258.89,
    width: 30.43,
    height: 106.44,
    rx: 12,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.01,
    y: 262.44,
    width: 20.56,
    height: 99.33,
    rx: 9.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.47,
    y: 258.89,
    width: 30.43,
    height: 106.44,
    rx: 12,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.94,353.5H200.46a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h26.48a2,2,0,0,1,2,2h0A2,2,0,0,1,226.94,353.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.94,277.33H200.46a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h26.48a2,2,0,0,1,2,2h0A2,2,0,0,1,226.94,277.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.32,297.06h74.11a7.23,7.23,0,0,0,7.23-7.22h0a7.23,7.23,0,0,0-7.23-7.22H299.32a7.22,7.22,0,0,0-7.22,7.22h0A7.22,7.22,0,0,0,299.32,297.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,258.08h0a10.55,10.55,0,0,1-8.16-12.47l10.52-50.32a10.53,10.53,0,0,1,12.47-8.16h0A10.53,10.53,0,0,1,361,199.6l-10.51,50.32A10.54,10.54,0,0,1,338,258.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.64,257h0a9,9,0,0,1-10.26-7.56l-6.57-43.48a9,9,0,0,1,7.56-10.25h0a9,9,0,0,1,10.26,7.56l6.57,43.47A9,9,0,0,1,331.64,257Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.43,208.63h0a3,3,0,0,1-3.93-1.5l-5.92-13.22a3,3,0,0,1,1.49-3.92h0a3,3,0,0,1,3.93,1.5l5.92,13.22A3,3,0,0,1,344.43,208.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,209.9h0a3,3,0,0,1-.4,4.18l-11.19,9.21a3,3,0,0,1-4.18-.41h0a3,3,0,0,1,.41-4.18l11.18-9.2A3,3,0,0,1,362.34,209.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.26,194h0a1.71,1.71,0,0,1,.87,2.24l-3.33,7.57a1.71,1.71,0,0,1-2.24.87h0a1.71,1.71,0,0,1-.87-2.24l3.33-7.57A1.71,1.71,0,0,1,330.26,194Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44,209.25h0a1.7,1.7,0,0,1,2.4.07l5.68,6a1.7,1.7,0,0,1-.07,2.4h0a1.7,1.7,0,0,1-2.4-.07l-5.68-6A1.7,1.7,0,0,1,312.44,209.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.96 282.62 316.8 282.62 308.63 244 364.13 244 355.96 282.62",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.45,250.66H312.31a6.66,6.66,0,0,1-6.66-6.66h0a6.66,6.66,0,0,1,6.66-6.65h48.14a6.66,6.66,0,0,1,6.66,6.65h0A6.66,6.66,0,0,1,360.45,250.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.51 382.4 306.79 297.06 320.42 297.06 295.68 382.4 290.51 382.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.25 382.4 365.98 297.06 352.34 297.06 377.08 382.4 382.25 382.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.34 382.4 340.51 297.06 326.88 297.06 347.17 382.4 352.34 382.4",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-6",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.39,330.33H92.65a3,3,0,0,1,0-6h45.74a3,3,0,0,1,0,6Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.39,330.33H92.65a3,3,0,0,1,0-6h45.74a3,3,0,0,1,0,6Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.58 407.52 186.32 404.43 183.07 387.03 176.34 390.13 179.58 407.52",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,402.58l-7.57,3.47a.53.53,0,0,0-.29.69l2.38,6.16a1.32,1.32,0,0,0,1.73.66c2.62-1.26,3.8-2,7.13-3.52,2.05-.94,10.86-4.72,13.68-6s1.47-4.06.15-3.76c-5.89,1.33-13.27,2.82-15.86,2.2A2.06,2.06,0,0,0,186,402.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.33 390.13 183.07 387.04 184.75 396.01 178 399.1 176.33 390.13",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.06,295.63s57.68,4.13,55.35,25.26c-3.34,30.37-.59,68.79-.59,68.79l-12.56,5.18s-11-42.81-8.07-66.48c-14.39-6-53.41-.25-58-12.68a40.75,40.75,0,0,1-1.72-20.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.16,313.22s-1.4,6.28-2.36,13.1l.13,0,1.48.23.75.14.85.16a31.68,31.68,0,0,1,3.43.88c.27.08.52.17.77.26s.67.24,1,.37a73.15,73.15,0,0,0-.51,8.79C174.45,324.3,166.93,313.22,160.16,313.22Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.13 398.99 189.38 391.53 188.33 385.55 171.62 391.66 173.13 398.99",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,402.66a9.73,9.73,0,0,1-1.91.58.16.16,0,0,1-.17-.07.17.17,0,0,1,0-.19c.14-.25,1.45-2.42,2.42-2.48a.63.63,0,0,1,.57.28.94.94,0,0,1,.2.94A2,2,0,0,1,189,402.66Zm-1.58.15c1.31-.31,2.18-.75,2.35-1.21a.59.59,0,0,0-.14-.61.29.29,0,0,0-.28-.14C188.8,400.88,187.94,402,187.39,402.81Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.1,403.23H187a.14.14,0,0,1-.14-.09c0-.07-1.09-1.94-.71-2.91a.83.83,0,0,1,.56-.52.66.66,0,0,1,.79.21c.49.66.14,2.53-.35,3.24Zm-.34-3.16a.5.5,0,0,0-.27.3,3.83,3.83,0,0,0,.54,2.34,3.44,3.44,0,0,0,.21-2.57c-.06-.09-.16-.17-.4-.1Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.87,235.51l7,20.3c1.19,3.38,2.37,6.75,3.59,10.08s2.47,6.65,3.81,9.81l-.33-.6a3.59,3.59,0,0,0-1.31-1.15,3.64,3.64,0,0,0-2-.41c-.91.12-.88.31-.78.24a6.09,6.09,0,0,0,1.58-1.09,49,49,0,0,0,3.95-3.95c1.33-1.45,2.64-3,4-4.51l3.94-4.64,4.78,2.86c-.83,2-1.77,3.88-2.73,5.79s-2,3.75-3.19,5.6a44.63,44.63,0,0,1-4,5.49,16.46,16.46,0,0,1-3.18,2.85,7.6,7.6,0,0,1-3.65,1.32,6.3,6.3,0,0,1-3.47-.72,6.6,6.6,0,0,1-2.42-2.22l-.12-.18-.21-.41c-1.68-3.4-3.16-6.76-4.58-10.16s-2.77-6.77-4.06-10.18-2.55-6.82-3.75-10.25-2.38-6.86-3.47-10.36Z",
    style: {
      fill: "#803e3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.13,236.61c6,6.92,10,16.6,10,16.6l-15.76,9.49c-4.55-5.54-10.22-20.22-10.46-25.17C119.56,229.92,129.63,229.16,136.13,236.61Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.57,243.67c3.44,2.89,5.88,8.9,7,14.73l-7.14,4.3c-2.25-2.74-4.78-7.71-6.79-12.65C125.2,245.15,127.53,241.11,130.57,243.67Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.8 406.94 140.22 406.94 143.61 389.78 136.2 389.78 132.8 406.94",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.45,405.14h-8.33a.53.53,0,0,0-.55.51l-.41,6.59a1.32,1.32,0,0,0,1.3,1.32c2.9-.05,4.29-.22,7.95-.22,2.25,0,9.9.23,13,.23s3-3.08,1.7-3.36c-5.91-1.25-11.3-3-13.4-4.61A2,2,0,0,0,140.45,405.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.2 389.78 143.61 389.78 141.86 398.63 134.44 398.63 136.2 389.78",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.53,295.63s48.88,4.13,47.68,25.35c-1.32,23.24-20.13,75.51-20.13,75.51H131.5s6.14-47.29,9.11-70.95c-13.77,0-42.36,2.59-46.94-9.84A40.75,40.75,0,0,1,92,295.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.04 396.49 147.92 396.49 148.94 389.44 130.28 390.28 130.04 396.49",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.07,406.43a9.5,9.5,0,0,1-2-.26.17.17,0,0,1-.06-.31c.24-.17,2.33-1.6,3.24-1.25a.67.67,0,0,1,.4.49,1,1,0,0,1-.21.94A2,2,0,0,1,143.07,406.43Zm-1.5-.51c1.33.26,2.31.22,2.65-.12a.62.62,0,0,0,.13-.62.3.3,0,0,0-.2-.24C143.67,404.75,142.43,405.37,141.57,405.92Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.14,406.17a.11.11,0,0,1-.08,0A.16.16,0,0,1,141,406c0-.09-.18-2.22.57-2.94a.89.89,0,0,1,.73-.24.67.67,0,0,1,.63.52c.17.81-.94,2.36-1.67,2.8Zm1-3a.53.53,0,0,0-.37.15,3.82,3.82,0,0,0-.49,2.35c.65-.54,1.38-1.72,1.27-2.25,0-.1-.08-.22-.33-.25Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.21,262.11l2.3-8.22,7.41,4.89s-4,7.12-6.51,6.54Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.38 250.55 170.25 255 166.92 258.78 159.51 253.88 166.38 250.55",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,296H92.36c-.28-3.54.54-15.06-.07-29.73a188.37,188.37,0,0,0-3.94-32.34c-.18-.8-.36-1.59-.55-2.39,0,0,2-.41,4.89-.83,2.39-.35,5.39-.71,8.33-.85a147.89,147.89,0,0,1,16.85,0c2.59.24,5.12.67,7.14,1.06,2.58.52,4.1,1,4.1,1S138.88,254.32,132,296Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.29,266.28a188.37,188.37,0,0,0-3.94-32.34c2.65-.23,7.18,0,7.93,4.31C97.09,242.85,96.07,253.67,92.29,266.28Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.49,241.33c-.87,2.47-1.81,5.13-2.64,7.72s-1.65,5.23-2.39,7.85a89.2,89.2,0,0,0-3.24,15.51l-.07.92,0,.46c0,.1,0,.46,0,.18a3.36,3.36,0,0,0-.64-1.58,3.33,3.33,0,0,0-1.68-1.24c-.38-.1-.48-.07-.49-.06a.62.62,0,0,0,.32,0,7.48,7.48,0,0,0,1.39-.22,49.53,49.53,0,0,0,7.22-2.58c5-2.14,10.07-4.62,15.07-7.08l3.06,4.64A114.42,114.42,0,0,1,97.1,276a48.64,48.64,0,0,1-8.37,4.09,18.14,18.14,0,0,1-2.75.73,11.17,11.17,0,0,1-1.79.19,8.18,8.18,0,0,1-2.59-.37,6.54,6.54,0,0,1-3.38-2.44A6.88,6.88,0,0,1,77,274.58a8.44,8.44,0,0,1,0-.87V271.9a62.89,62.89,0,0,1,.91-9.16c.48-3,1.1-5.86,1.82-8.71s1.5-5.67,2.4-8.45,1.8-5.49,2.94-8.31Z",
    style: {
      fill: "#803e3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8,231.55c7.22-2.28,11.84,3.49,9.84,13.5a65.47,65.47,0,0,1-6.86,18.26l-14.59-6.92C77.58,246.58,80.41,233.88,87.8,231.55Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.38,211l4.51,3.74,6.14,5.1a19.92,19.92,0,0,0-.39,2.48c-.33,3.33.53,6.36,5.43,7.52,0,0,4.82,4.5-4.82,4.64s-11.88-4.54-11.88-4.54C104,226.29,102.63,216.4,101.38,211Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,219.81a19.92,19.92,0,0,0-.39,2.48c-2.29-.46-5.35-2.9-5.67-5.24a10.66,10.66,0,0,1-.08-2.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.18,205.35c1.77-4,.66-9.79-2.34-11.94a4.38,4.38,0,0,0-7,3.58C109.68,201.91,117.16,209.9,119.18,205.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.52,203.16c1.57,7.21,2.12,11.49,6.38,14.78a9.59,9.59,0,0,0,15.51-6.9c.56-6.71-2.09-17.38-9.68-19.42A9.71,9.71,0,0,0,99.52,203.16Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.58,208.78c2.29-3.74,1.93-9.62-.75-12.14a4.39,4.39,0,0,0-7.46,2.63C93.61,204.14,100,213,102.58,208.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.18,
    cy: 196.89,
    r: 3.35,
    transform: "translate(-79.32 69.36) rotate(-27.48)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.54,195.52a3,3,0,1,1-1.93-3.72A3,3,0,0,1,102.54,195.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.57,195a3,3,0,1,1-1.95-3.75A3,3,0,0,1,107.57,195Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.63,191.71a3.93,3.93,0,1,1-2.56-4.92A3.91,3.91,0,0,1,101.63,191.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.52,189.65a4,4,0,1,1-2.61-5A4,4,0,0,1,107.52,189.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.72,188.27a4,4,0,1,1-2.62-5A4,4,0,0,1,112.72,188.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.76,188.29a4,4,0,1,1-2.63-5.07A4,4,0,0,1,118.76,188.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.77,195.93a3.61,3.61,0,1,1-2.35-4.53A3.61,3.61,0,0,1,98.77,195.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,192.65a3.26,3.26,0,1,1-2.13-4.09A3.26,3.26,0,0,1,111,192.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,192.35a2.77,2.77,0,1,1-1.81-3.47A2.77,2.77,0,0,1,115,192.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,190.2a2.76,2.76,0,1,1-1.8-3.47A2.76,2.76,0,0,1,121.1,190.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.63,192.46a2.65,2.65,0,1,1-1.73-3.32A2.64,2.64,0,0,1,118.63,192.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.56,188.91a2.18,2.18,0,1,1-1.42-2.73A2.17,2.17,0,0,1,123.56,188.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.65,190.92a1.3,1.3,0,1,1-.84-1.62A1.29,1.29,0,0,1,124.65,190.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.07,192.53a1.3,1.3,0,1,1-.85-1.63A1.31,1.31,0,0,1,103.07,192.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.35,209.84a6.56,6.56,0,0,0,4,2.45c2,.36,2.66-1.51,1.76-3.33-.82-1.64-2.85-3.8-4.74-3.34S97.14,208.25,98.35,209.84Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.87,203.82c.09.59.48,1,.87,1s.63-.56.54-1.15-.48-1-.87-1S111.78,203.23,111.87,203.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.58,203c.09.59.48,1,.87,1s.63-.57.54-1.16-.48-1-.87-1S118.49,202.43,118.58,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.54,203.26a18.85,18.85,0,0,0,2.8,4.21,2.87,2.87,0,0,1-2.39.58Z",
    style: {
      fill: "#630f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.2,211.09a5.15,5.15,0,0,1-3.73-1.54.17.17,0,0,1,.26-.23,5,5,0,0,0,4.13,1.38.18.18,0,0,1,.19.15.18.18,0,0,1-.15.2A5.58,5.58,0,0,1,114.2,211.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,200.41a.44.44,0,0,1-.15-.08.35.35,0,0,1,0-.5,3.38,3.38,0,0,1,3-1.16.34.34,0,0,1,.28.41.34.34,0,0,1-.4.28,2.67,2.67,0,0,0-2.31.94A.37.37,0,0,1,109.17,200.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,200a.34.34,0,0,1-.32-.07,3,3,0,0,0-2.51-.68.34.34,0,0,1-.43-.24.35.35,0,0,1,.24-.43h0a3.62,3.62,0,0,1,3.14.81.36.36,0,0,1,.05.5A.45.45,0,0,1,121,200Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.79,262.05l2.6-6.32,5.48,5.83s-2.65,6.2-5.73,4.56Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.22 251.48 119.27 256.52 114.87 261.56 109.39 255.72 116.22 251.48",
    style: {
      fill: "#7f3e3b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 278.24,
    cy: 188.55,
    r: 8.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.27,197.54a9,9,0,1,1,9-9A9,9,0,0,1,280.27,197.54Zm0-17.47a8.49,8.49,0,1,0,8.49,8.48A8.49,8.49,0,0,0,280.27,180.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.9,202.59a9,9,0,1,1,9-9A9,9,0,0,1,260.9,202.59Zm0-17.48a8.49,8.49,0,1,0,8.49,8.49A8.49,8.49,0,0,0,260.9,185.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.77,
    cy: 193.41,
    r: 8.95,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.09,179.86C252,185,255.73,194,259.65,194.49s4.69-9.3,1.29-13.57S253.91,176.12,253.09,179.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.42,218.82c.47,2.83.72,5.48.93,8.23s.25,5.47.21,8.23a66.57,66.57,0,0,1-2.16,16.61c-1.55,5.3-3.41,10.25-5.34,15.24l-3,7.42c-1.05,2.45-2.06,4.9-3.17,7.34l-3.52-1.28,2.17-7.65,2.21-7.62,2.16-7.6c.72-2.52,1.4-5.07,2-7.52a64.06,64.06,0,0,0,1.22-14.95c0-2.55-.16-5.11-.37-7.66s-.48-5.17-.79-7.58Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.41,211.18c-2.79,1.43-2.09,14.12-2.09,14.12l13.11,5.14s1.37-15.54-1.65-18.29S257.5,209.09,253.41,211.18Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.3 213.85 254.82 226.68 260.13 228.75 254.3 213.85",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.84,278.71l-8.34,3.4,6.42,3.4s4.28-2.06,4.41-5.12Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.01 406.03 261.62 406.03 260.37 388.92 267.76 388.92 269.01 406.03",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.02 395 302.77 396.43 297.13 380.11 304.37 378.68 310.02 395",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.71,395.18l7.81-2.8a.58.58,0,0,1,.72.28l3.11,5.86a1.19,1.19,0,0,1-.67,1.64c-2.74.93-4.11,1.24-7.55,2.47-2.11.75-6.13,3-9.05,4s-4.1-1.79-3-2.48a19.21,19.21,0,0,0,7.6-8.16A1.94,1.94,0,0,1,301.71,395.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.07,405.17h8.3a.58.58,0,0,1,.58.51l.95,6.56a1.19,1.19,0,0,1-1.18,1.32c-2.9-.05-4.29-.22-7.94-.22-2.25,0-6.89.23-10,.23s-3.26-3.07-2-3.34c5.78-1.25,8.06-3,10-4.6A1.92,1.92,0,0,1,261.07,405.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "260.37 388.93 261.05 398.24 268.44 398.24 267.76 388.93 260.37 388.93"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "304.38 378.68 297.13 380.12 300.28 389.21 307.45 387.56 304.38 378.68"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M253.41,211.18s-3.15,2,13.33,42.69L296,247.22c-3.2-11.79-4.88-19.13-4.74-44.86a88.34,88.34,0,0,0-12.8,1.19,95.22,95.22,0,0,0-13.28,3C259.58,208.39,253.41,211.18,253.41,211.18Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.24,206.33a11.91,11.91,0,0,0-4.73,6.87c-.77,3.53,4.13,9.49,5.28,10.82C291.44,219.29,291.26,213.61,291.24,206.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.1,190.49c.14,4.47.71,10.89,4.35,13.06a31.63,31.63,0,0,1-9.08,14.36c-7-3.39-4.2-11.34-4.2-11.34,4.51-2.22,3.95-4.13,2.36-7.26Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.42,194.09l-3.89,5.22a13.74,13.74,0,0,1,1,2.26c1.76-.68,4.27-2.88,4.21-4.95A5.81,5.81,0,0,0,271.42,194.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.59,179.71c2.19,7,3.26,9.91,1.15,14.74-3.19,7.26-12.26,8.41-16.49,2.21-3.81-5.58-6.75-16.09-1.09-21.36A10,10,0,0,1,273.59,179.71Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.74,253.87s-16.8,42.78-16.32,65.3c.51,23.43,9.09,76.87,9.09,76.87h10S267.92,344,268.8,321c1-25.08,19.36-72,19.36-72Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.74,253.87s-16.8,42.78-16.32,65.3c.51,23.43,9.09,76.87,9.09,76.87h10S267.92,344,268.8,321c1-25.08,19.36-72,19.36-72Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.37 396.39 258.65 396.39 257.79 392.66 270.91 392.2 270.37 396.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.4,267c-5.72,10.13-5.21,26.65-3.67,39.1a307.87,307.87,0,0,1,9.73-35.49C279.66,263.89,277.91,260.78,274.4,267Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.46,252.11s-4,46.79,1.16,65.78C281.71,340.44,298,387.2,298,387.2l9.88-1.95s-8-53.95-12.7-65.83c-9.94-25.35,12.26-57.83.85-72.2Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.46,252.11s-4,46.79,1.16,65.78C281.71,340.44,298,387.2,298,387.2l9.88-1.95s-8-53.95-12.7-65.83c-9.94-25.35,12.26-57.83.85-72.2Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.08 385.54 296.82 387.96 294.76 384.37 309.05 380.86 309.08 385.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.38,185.68c.21.56.09,1.12-.28,1.26s-.83-.2-1-.76-.09-1.12.27-1.25S263.17,185.13,263.38,185.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.09,188.08c.21.56.09,1.12-.28,1.26s-.83-.2-1-.76-.09-1.12.27-1.26S256.87,187.52,257.09,188.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.22,187.29l-1.49.13S255.82,188.2,256.22,187.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.41,188.34a15.86,15.86,0,0,1-.63,4.31,2.54,2.54,0,0,0,2.12-.38Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77,193.29a5.26,5.26,0,0,1-.79.38.18.18,0,0,1-.23-.1.17.17,0,0,1,.1-.23,4.75,4.75,0,0,0,2.94-3.1.17.17,0,0,1,.34.08A4.93,4.93,0,0,1,264.77,193.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.19,176.42c2.25,5.68,11.94,10.63,15.42,9.12,4.16-1.81,3-10.81-3.68-13.64C267.34,169.52,259.55,172.28,261.19,176.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.51,171.52c-2.2-2.18-15.4-1.64-16.51,4.15-1.54,8,6.14,6.19,10.34,4.53C265.71,178.09,269.39,174.37,266.51,171.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.35,186.31a5.37,5.37,0,0,1-1.62,3.76c-1.35,1.3-2.91.3-3.28-1.44-.33-1.57,0-4.13,1.7-4.77A2.4,2.4,0,0,1,277.35,186.31Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,183a.36.36,0,0,1-.4-.1,4.15,4.15,0,0,0-3.16-1,.35.35,0,1,1-.07-.7,4.77,4.77,0,0,1,3.75,1.26.35.35,0,0,1,0,.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.29,186a.34.34,0,0,1-.34,0,.36.36,0,0,1-.14-.48,3.46,3.46,0,0,1,2.64-1.8.35.35,0,0,1,.37.33.35.35,0,0,1-.33.37,2.75,2.75,0,0,0-2.07,1.45A.33.33,0,0,1,253.29,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.39,397.39l-.08,0a1,1,0,0,1-.59-.78.62.62,0,0,1,.16-.58c.68-.65,3.28-.05,3.57,0a.2.2,0,0,1,.14.14.18.18,0,0,1-.08.18C300.71,396.86,299.27,397.67,298.39,397.39Zm2.57-1.12c-1-.21-2.48-.36-2.83,0a.25.25,0,0,0-.07.26.69.69,0,0,0,.38.53C298.91,397.24,299.83,397,301,396.27Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.12,396.3c-.88-.28-2.35-1.2-2.46-2a.62.62,0,0,1,.39-.66,1,1,0,0,1,.78,0c1,.4,1.72,2.4,1.75,2.49a.18.18,0,0,1,0,.17.21.21,0,0,1-.17.06ZM299.65,394a.56.56,0,0,0-.44,0c-.2.11-.22.22-.2.3.07.51,1.26,1.36,2.11,1.65-.27-.66-.83-1.72-1.42-2Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.29,406.46a2.79,2.79,0,0,1-1.79-.45,1,1,0,0,1-.31-.85.58.58,0,0,1,.29-.47c.91-.5,3.85,1,4.19,1.18a.19.19,0,0,1,.09.18.17.17,0,0,1-.14.15A13,13,0,0,1,258.29,406.46ZM257,404.94a.63.63,0,0,0-.33.06.2.2,0,0,0-.11.19.6.6,0,0,0,.2.56c.44.4,1.66.47,3.3.2A9.45,9.45,0,0,0,257,404.94Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.58,406.2h-.07c-.88-.4-2.62-2-2.48-2.83,0-.2.17-.45.65-.49a1.23,1.23,0,0,1,1,.3c.93.77,1.1,2.76,1.11,2.84a.18.18,0,0,1-.07.16A.2.2,0,0,1,260.58,406.2Zm-1.76-3h-.1c-.32,0-.34.16-.35.21-.08.5,1.1,1.75,2,2.3a4.06,4.06,0,0,0-.94-2.28A.88.88,0,0,0,258.82,403.21Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.51,184.89,261,185S262.11,185.8,262.51,184.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,245.4l1.34,2.45c.15.18,0,.44-.38.52l-30.11,6.84c-.26.06-.51,0-.57-.18l-.85-2.56c-.06-.17.13-.38.42-.44l29.62-6.74A.57.57,0,0,1,296,245.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.71,249.64l.8-.18c.15,0,.26-.14.22-.24l-1.14-3.32a.32.32,0,0,0-.35-.11l-.79.18c-.16,0-.26.15-.23.24l1.15,3.32C292.4,249.63,292.56,249.68,292.71,249.64Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.71,249.64l.8-.18c.15,0,.26-.14.22-.24l-1.14-3.32a.32.32,0,0,0-.35-.11l-.79.18c-.16,0-.26.15-.23.24l1.15,3.32C292.4,249.63,292.56,249.68,292.71,249.64Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.18,255l.8-.18c.16,0,.26-.14.22-.24l-1.14-3.32a.29.29,0,0,0-.35-.11l-.79.18c-.16,0-.26.15-.23.24l1.15,3.32C268.87,255,269,255,269.18,255Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.18,255l.8-.18c.16,0,.26-.14.22-.24l-1.14-3.32a.29.29,0,0,0-.35-.11l-.79.18c-.16,0-.26.15-.23.24l1.15,3.32C268.87,255,269,255,269.18,255Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.9,252.33l.79-.18c.16,0,.26-.15.23-.24l-1.15-3.32c0-.1-.19-.15-.34-.11l-.8.18c-.16,0-.26.14-.22.24l1.14,3.32A.32.32,0,0,0,280.9,252.33Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.9,252.33l.79-.18c.16,0,.26-.15.23-.24l-1.15-3.32c0-.1-.19-.15-.34-.11l-.8.18c-.16,0-.26.14-.22.24l1.14,3.32A.32.32,0,0,0,280.9,252.33Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.67 286.89 240.56 288.35 243.92 285.51 237.5 282.11 234.67 286.89",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.68,238.49,275.93,233l-.5,7.5s4,2.55,6.68,1.06Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,209.18c.26.33.39.52.57.77l.48.69q.45.69.87,1.38.82,1.38,1.56,2.79,1.41,2.82,2.54,5.73c.77,1.93,1.41,3.91,2,5.89.29,1,.53,2,.78,3l.1.38.11.48a7.66,7.66,0,0,1,.18,1.31,7,7,0,0,1-.46,2.83,8.14,8.14,0,0,1-3.12,3.7,15.13,15.13,0,0,1-3.35,1.63,30.91,30.91,0,0,1-6.35,1.4,61.66,61.66,0,0,1-12.29.22v-3.74c1.88-.23,3.83-.47,5.71-.8s3.78-.66,5.59-1.12A30.44,30.44,0,0,0,296,234a9.06,9.06,0,0,0,1.89-1.12c.48-.39.65-.74.61-.79s0,0,0-.09l-.24-.72c-.3-.9-.6-1.8-.94-2.68-.61-1.79-1.36-3.53-2.08-5.25s-1.55-3.41-2.43-5c-.42-.81-.87-1.62-1.33-2.39-.23-.39-.47-.76-.71-1.13l-.34-.54-.3-.43Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.25,202.36c3.13.23,8.94,9.52,8.94,9.52l-8.9,9.64S284.61,215.11,285,211C285.37,206.81,287.67,202.1,291.25,202.36Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.75 232.31 269.68 238.61 275.43 240.45 275.93 232.95 269.75 232.31",
    style: {
      fill: "#ff8b7b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.48,330.33H344.74a3,3,0,0,1,0-6h45.74a3,3,0,0,1,0,6Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.48,330.33H344.74a3,3,0,0,1,0-6h45.74a3,3,0,0,1,0,6Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.37 406.94 323.96 406.94 319.65 389.78 327.06 389.78 331.37 406.94",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.44,405.14h8.33a.53.53,0,0,1,.55.51l.4,6.59a1.32,1.32,0,0,1-1.3,1.32c-2.9-.05-4.28-.22-7.94-.22-2.26,0-11.84.23-15,.23s-3-3.08-1.7-3.36c5.91-1.25,13.24-3,15.33-4.61A2.09,2.09,0,0,1,323.44,405.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.07 389.78 319.65 389.78 321.88 398.63 329.29 398.63 327.07 389.78",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.08,295.63S290.75,299.76,292,321c1.32,23.24,26.69,75.51,26.69,75.51h13.58s-12.31-44.44-15.28-68.11c14.39-6,53.42-.25,58-12.68a40.75,40.75,0,0,0,1.72-20.07Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.68,333.57c-.17-1.06-.32-2.1-.46-3.1-.1-.71-.2-1.41-.28-2.09a35.86,35.86,0,0,1,8.39-2.06c-1-6.82-2.36-13.1-2.36-13.1-7,0-14.89,12-4.41,25.48q-.26-1.38-.48-2.73C317.94,335.16,317.81,334.35,317.68,333.57Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.68 396.49 315.8 396.49 314.26 390.62 331.99 389.21 333.68 396.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.81,406.43a9.6,9.6,0,0,0,2-.26.2.2,0,0,0,.13-.14.19.19,0,0,0-.07-.17c-.24-.17-2.34-1.6-3.24-1.25a.7.7,0,0,0-.41.49,1,1,0,0,0,.22.94A2,2,0,0,0,320.81,406.43Zm1.5-.51c-1.32.26-2.3.22-2.65-.12a.64.64,0,0,1-.12-.62.3.3,0,0,1,.19-.24C320.22,404.75,321.45,405.37,322.31,405.92Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.75,406.17a.13.13,0,0,0,.08,0,.18.18,0,0,0,.09-.14c0-.09.17-2.22-.57-2.94a.91.91,0,0,0-.74-.24.66.66,0,0,0-.62.52c-.17.81.93,2.36,1.67,2.8Zm-1-3a.54.54,0,0,1,.38.15,3.88,3.88,0,0,1,.48,2.35c-.64-.54-1.38-1.72-1.27-2.25,0-.1.08-.22.33-.25Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.84,239.29c-1.13,3.11-2.36,6.15-3.57,9.21s-2.48,6.1-3.79,9.12c-2.59,6.07-5.3,12.08-8.3,18.07l-.43.85-.44.45a30.92,30.92,0,0,1-7.22,5.38,36.84,36.84,0,0,1-8,3.17,44.79,44.79,0,0,1-8.18,1.42c-1.37.12-2.73.15-4.09.15a37.71,37.71,0,0,1-4.17-.23l.11-5.57c1.05-.16,2.31-.37,3.46-.61s2.34-.54,3.49-.85a47.1,47.1,0,0,0,6.63-2.3,33.37,33.37,0,0,0,5.86-3.23,23.69,23.69,0,0,0,4.63-4.2l-.87,1.3c2.48-5.9,4.83-12,7.21-18l3.57-9.09,3.61-9.06Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,236.61c-6,6.92-10,16.6-10,16.6l15.76,9.49c4.55-5.54,10.23-20.22,10.46-25.17C363.57,229.92,353.5,229.16,347,236.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.56,243.67c-3.44,2.89-5.88,8.9-6.95,14.73l7.14,4.3c2.25-2.74,4.78-7.71,6.79-12.65C357.93,245.15,355.6,241.11,352.56,243.67Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.63 402.29 353.42 403.99 346.17 388.06 353.39 386.36 360.63 402.29",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.18,402l7.81-2.88a.55.55,0,0,1,.7.29l2.65,6a1.39,1.39,0,0,1-.76,1.69c-2.56,1.36-4,1.45-7.53,2.54-1.55.47-5.49,3.74-10.05,3.74h-4c-2.36,0-2.68-2.52-1.37-2.87,6.33-1.69,10.08-5.41,11.48-7.68A2,2,0,0,1,352.18,402Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.39 386.36 346.17 388.06 349.91 396.27 357.13 394.57 353.39 386.36",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.6,295.63s-48.88,4.13-47.68,25.35c1.32,23.24,28.37,73.95,28.37,73.95l13.21-3.11s-14-42.62-17-66.28c13.78,0,42.36,2.59,47-9.84a40.75,40.75,0,0,0,1.72-20.07Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.92 391.48 343.52 395.58 341.67 389.73 359.29 384.55 360.92 391.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.16,404.16a9.63,9.63,0,0,0,1.76-.93.18.18,0,0,0,.08-.17.17.17,0,0,0-.13-.14c-.28-.07-2.74-.7-3.47-.05a.66.66,0,0,0-.21.6.92.92,0,0,0,.53.8A2,2,0,0,0,350.16,404.16Zm1.23-1c-1.15.7-2.08,1-2.53.8a.63.63,0,0,1-.33-.54.33.33,0,0,1,.1-.29C349,402.78,350.39,402.94,351.39,403.16Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.89,403.25a.15.15,0,0,0,.06-.05.16.16,0,0,0,0-.16c0-.09-.6-2.15-1.55-2.56a.84.84,0,0,0-.77,0,.67.67,0,0,0-.41.71c.12.82,1.69,1.89,2.54,2.05Zm-2-2.47a.51.51,0,0,1,.4,0c.57.25,1,1.38,1.27,2-.79-.28-1.89-1.13-2-1.67,0-.1,0-.23.22-.35Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.08,281.16l-8.37-1.71,1.05,8.14s8.1.35,8.71-2.12Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.6 284.05 299.8 289.52 304.76 287.59 303.71 279.45 297.6 284.05",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.12,296h39.65c.28-3.54-.54-15.06.07-29.73a188.37,188.37,0,0,1,3.94-32.34c.18-.8-.19-1.39,0-2.19a19.8,19.8,0,0,0-4.34-1c-2.39-.35-5.39-.71-8.33-.85a147.89,147.89,0,0,0-16.85,0c-2.59.24-5.12.67-7.14,1.06-2.58.52-4.1,1-4.1,1S344.25,254.32,351.12,296Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.84,266.28a188.37,188.37,0,0,1,3.94-32.34c-2.65-.23-7.18,0-7.93,4.31C386,242.85,387.06,253.67,390.84,266.28Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.12,237.27c1.17,2.89,2.07,5.65,3,8.52s1.73,5.72,2.44,8.65,1.36,5.89,1.82,8.95c.25,1.5.42,3.07.6,4.62s.23,3.16.2,4.83v1.22a8.4,8.4,0,0,1-.45,2.63,10.08,10.08,0,0,1-2.21,3.58,19,19,0,0,1-4.67,3.44,48,48,0,0,1-8.86,3.56,100.7,100.7,0,0,1-17.62,3.52l-1.15-5.45c2.65-.92,5.38-1.87,8-2.89s5.27-2,7.78-3.18a47,47,0,0,0,6.94-3.69,9.08,9.08,0,0,0,2.15-1.89c.18-.23.16-.35,0-.12a1.15,1.15,0,0,0-.07.24l0,.16v.08h0l-.08-.94a56,56,0,0,0-1.18-7.81c-.56-2.66-1.24-5.35-2-8s-1.58-5.36-2.45-8-1.8-5.38-2.7-7.91Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.78,231.75c-7.22-2.28-11.29,3.29-9.29,13.3a65.66,65.66,0,0,0,6.87,18.26l14.58-6.92C405.56,246.58,402.17,234.08,394.78,231.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.09,213l-4.51,3.74-6.14,5.1a19.92,19.92,0,0,1,.39,2.48c.33,3.33-2.37,4.88-5.77,5.52,0,0-4.82,4.5,4.82,4.64s11.88-4.54,11.88-4.54C379.09,226.29,380.84,218.4,382.09,213Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.83,229.88a29.27,29.27,0,0,1-10.38,4.56c1.89,1.88,3.11,6.5,3.11,6.5S385,238.49,385.38,230a8.16,8.16,0,0,0-1.73-.55A2.4,2.4,0,0,0,381.83,229.88Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.82,230.08c-.24,1.18,0,3.34,4.63,4.36-2.85,1.64-4.07,6-4.07,6s-6.46-5.67-3.14-10.57a8.07,8.07,0,0,1,1.89-.56A.61.61,0,0,1,366.82,230.08Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.44,221.81a19.92,19.92,0,0,1,.39,2.48c3.8-.58,6.26-2.83,6.58-5.16.12-.88-.77-1.81-.83-2.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.66,210.37c-3.52-2.61-5.4-8.19-3.86-11.54a4.4,4.4,0,0,1,7.9-.35C372.23,202.71,369.66,213.34,365.66,210.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.4,203.41c.06,7.38.48,11.68-2.95,15.83a9.59,9.59,0,0,1-16.66-3.3c-2-6.42-1.8-17.4,5.14-21.07A9.71,9.71,0,0,1,382.4,203.41Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.85,209.28c-2.66-3.49-2.91-9.37-.49-12.16A4.39,4.39,0,0,1,387,199C388.29,203.74,382.86,213.24,379.85,209.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.54,197.73c-2.23-1.34,2.92-5.87,9.6-7.85,7.46-2.21,16.89,3.59,17.35,8.62.48,5.3-3.1,2.72-3.66,4.38C386.83,202.88,368.11,200.48,363.54,197.73Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.28,199.58a5.15,5.15,0,0,1,1.26-2.91c.38-.35,22.5,4.11,24.8,6.09.43.37-1.12,3.53-1.46,3.12C383.46,203,361.37,200.38,361.28,199.58Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.28,199.58a5.15,5.15,0,0,1,1.26-2.91c.38-.35,22.5,4.11,24.8,6.09.43.37-1.12,3.53-1.46,3.12C383.46,203,361.37,200.38,361.28,199.58Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.79,207.61a.25.25,0,0,0,.11,0,.25.25,0,0,0,.08-.34c-1.19-1.95-9.35-2.61-10.27-2.68a33.78,33.78,0,0,0-7.89.52,2.31,2.31,0,0,0-2,.19,23.74,23.74,0,0,0-5.12.5.25.25,0,0,0-.19.3.25.25,0,0,0,.3.19,23.35,23.35,0,0,1,5.06-.49.31.31,0,0,0,.13,0,1.8,1.8,0,0,1,1.63-.18.25.25,0,0,0,.17,0,32.36,32.36,0,0,1,7.83-.53c2.45.18,9,1,9.88,2.44A.26.26,0,0,0,384.79,207.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.4,211.44l.24,0a3.45,3.45,0,0,0,2.53-1.52c1.26-1.95.41-5,.38-5.1a.13.13,0,0,0-.16-.09.13.13,0,0,0-.08.16s.85,3-.35,4.9a3.16,3.16,0,0,1-2.36,1.4,3.09,3.09,0,0,1-2.55-.65c-1.84-1.55-2-5.16-2-5.19a.13.13,0,0,0-.13-.13.14.14,0,0,0-.12.13c0,.15.12,3.76,2.05,5.38A3.3,3.3,0,0,0,371.4,211.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.55,212.08a2.68,2.68,0,0,0,2-1c1.35-1.8.51-5.22.48-5.36a.13.13,0,0,0-.25.06s.85,3.45-.43,5.15a2.47,2.47,0,0,1-2,1,1.71,1.71,0,0,1-1.39-.57c-1.33-1.47-.84-5.25-.84-5.29a.12.12,0,0,0-.1-.14.12.12,0,0,0-.14.1c0,.16-.51,4,.9,5.5a2,2,0,0,0,1.58.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,209.67a6.58,6.58,0,0,1-3.32,3.27c-1.91.8-2.92-.89-2.45-2.87.43-1.78,1.94-4.33,3.88-4.3S385.85,207.85,385,209.67Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.5,206.79c0,.59-.24,1.11-.63,1.15s-.73-.41-.78-1,.24-1.12.63-1.16S370.46,206.19,370.5,206.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.78,207.5c0,.59-.24,1.11-.63,1.15s-.74-.41-.78-1,.24-1.11.63-1.15S363.74,206.9,363.78,207.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,207.8a22.24,22.24,0,0,1-2.12,5.55,3.41,3.41,0,0,0,2.89.05Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.84,214.4a5.16,5.16,0,0,0,3.3-2.33.19.19,0,0,0-.07-.24.18.18,0,0,0-.24.08,4.94,4.94,0,0,1-3.72,2.25.18.18,0,0,0-.15.2.17.17,0,0,0,.19.15A5,5,0,0,0,369.84,214.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.54,203.9a.34.34,0,0,0,.06-.6,3.42,3.42,0,0,0-3.14-.48.35.35,0,0,0-.19.46.36.36,0,0,0,.46.19,2.71,2.71,0,0,1,2.46.4A.32.32,0,0,0,373.54,203.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.78,205.1a.36.36,0,0,0,.3-.13,2.94,2.94,0,0,1,2.29-1.22.35.35,0,0,0,.37-.33.35.35,0,0,0-.33-.37h0a3.61,3.61,0,0,0-2.88,1.49.34.34,0,0,0,.07.49A.26.26,0,0,0,360.78,205.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.08,285l-6.13-3-.26,8s6.08,2.89,7.31-.37Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.01 283.25 359.12 290.34 366.69 289.93 366.95 281.92 359.01 283.25",
    style: {
      fill: "#ffb573"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.4,416.24h-6V301.84a9,9,0,0,0-9-9H141.13a9,9,0,0,0-9,9v114.4h-6V301.84a15,15,0,0,1,15-15H380.4a15,15,0,0,1,15,15Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.4,416.24h-6V301.84a9,9,0,0,0-9-9H141.13a9,9,0,0,0-9,9v114.4h-6V301.84a15,15,0,0,1,15-15H380.4a15,15,0,0,1,15,15Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.87,416.24h-6V301.84a9,9,0,0,0-9-9H119.6a9,9,0,0,0-9,9v114.4h-6V301.84a15,15,0,0,1,15-15H358.87a15,15,0,0,1,15,15Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.87,416.24h-6V301.84a9,9,0,0,0-9-9H119.6a9,9,0,0,0-9,9v114.4h-6V301.84a15,15,0,0,1,15-15H358.87a15,15,0,0,1,15,15Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.08,284.41H191.54a3.07,3.07,0,0,1-3-2.68l-3.44-32.46a2.36,2.36,0,0,1,2.39-2.67h51.54a3.06,3.06,0,0,1,3,2.67l3.44,32.46A2.37,2.37,0,0,1,243.08,284.41Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.08,284.41H191.54a3.07,3.07,0,0,1-3-2.68l-3.44-32.46a2.36,2.36,0,0,1,2.39-2.67h51.54a3.06,3.06,0,0,1,3,2.67l3.44,32.46A2.37,2.37,0,0,1,243.08,284.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.63,
    y: 243.1,
    width: 4.17,
    height: 1,
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.38,
    y: 243.1,
    width: 9.67,
    height: 1,
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.65,284.41H190.12a3.05,3.05,0,0,1-3-2.68l-3.45-32.46a2.37,2.37,0,0,1,2.39-2.67h51.54a3.05,3.05,0,0,1,3,2.67l3.45,32.46A2.38,2.38,0,0,1,241.65,284.41Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,284.17H192.5a2.68,2.68,0,0,0-2.68,2.67h56.89A2.68,2.68,0,0,0,244,284.17Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.67,284.17H243.26a2.68,2.68,0,0,0-2.67,2.67h23.76A2.68,2.68,0,0,0,261.67,284.17Z",
    style: {
      fill: "#242B5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.67,284.17H243.26a2.68,2.68,0,0,0-2.67,2.67h23.76A2.68,2.68,0,0,0,261.67,284.17Z",
    style: {
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.184fd00515ea7e008fd229b15522925d.svg";
export { ForwardRef as ReactComponent };